module.exports = __webpack_public_path__ + "static/media/featured_img1.83f10117.png";